import { useClubGalleryList } from '@/features/configuration-management/groups-management/hooks/useClubGalleryList';
import { SubGroupClubGalleryTable } from '@/features/configuration-management/groups-management/subgroup-club-gallery/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['imageTitle', 'image', 'updatedOn']),
  desc: z.boolean(),
});

const ClubGallerySearchSchema = z.object({
  breadcrumbReturnTo: z.string().optional(),

  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  q: z.string().optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
    .optional(),

  page: z.coerce.number().positive().catch(1),
});

export const Route = createFileRoute('/(app)/configuration-management/group-management/$sub-group/$club-gallery')({
  component: RouteComponent,
  loader: ({ params }) => {
    return {
      crumb: params['club-gallery'],
      title: params['club-gallery'] + ' Gallery',
    };
  },
  validateSearch: (search: SearchSchemaInput) => ClubGallerySearchSchema.parse(search),
});

function RouteComponent() {
  const { clubGalleryList } = useClubGalleryList();
  return <SubGroupClubGalleryTable data={clubGalleryList} />;
}
